// Hand-drawn-feeling SVG icon set. Do NOT swap for Lucide.

type Dir = "r" | "l" | "u" | "d";

const stroke = {
  fill: "none" as const,
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const Icon = {
  camera: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M4 8 L7 8 L9 5 L15 5 L17 8 L20 8 L20 19 L4 19 Z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  ),
  plus: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M12 5 V19 M5 12 H19" />
    </svg>
  ),
  check: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M4 12 L10 18 L20 6" />
    </svg>
  ),
  x: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <path d="M6 6 L18 18 M18 6 L6 18" />
    </svg>
  ),
  chev: (s = 14, dir: Dir = "r") => (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      {...stroke}
      strokeWidth="2"
      style={{
        transform: { r: "", l: "rotate(180deg)", u: "rotate(-90deg)", d: "rotate(90deg)" }[dir],
      }}
    >
      <path d="M9 6 L15 12 L9 18" />
    </svg>
  ),
  share: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M12 4 V15 M12 4 L7 9 M12 4 L17 9" />
      <path d="M5 14 V20 H19 V14" />
    </svg>
  ),
  tag: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M3 3 L11 3 L21 13 L13 21 L3 11 Z" />
      <circle cx="7" cy="7" r="1.5" fill="currentColor" />
    </svg>
  ),
  history: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M3 12 A9 9 0 1 0 6 5.5" />
      <path d="M3 3 V8 H8" />
      <path d="M12 7 V12 L15 15" />
    </svg>
  ),
  closet: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M5 4 H19 V20 H5 Z M12 4 V20" />
      <circle cx="9" cy="12" r="0.8" fill="currentColor" />
      <circle cx="15" cy="12" r="0.8" fill="currentColor" />
    </svg>
  ),
  sparkle: (s = 14) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2 L13.5 9 L20 10.5 L13.5 12 L12 19 L10.5 12 L4 10.5 L10.5 9 Z" />
    </svg>
  ),
  search: (s = 16) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.8">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20 L16 16" />
    </svg>
  ),
  home: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M4 11 L12 4 L20 11 V20 H14 V14 H10 V20 H4 Z" />
    </svg>
  ),
  feed: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M4 6 H20 M4 12 H20 M4 18 H14" />
    </svg>
  ),
  user: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20 C5 15 9 13 12 13 C15 13 19 15 20 20" />
    </svg>
  ),
  grail: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M6 4 H18 V8 C18 11 15.5 13 12 13 C8.5 13 6 11 6 8 Z" />
      <path d="M12 13 V18 M8 20 H16" />
    </svg>
  ),
  mail: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M3 6 H21 V18 H3 Z" />
      <path d="M3 6 L12 13 L21 6" />
    </svg>
  ),
  gear: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      {/* Proper cog: 8 rectangular teeth around a circular body + center hub */}
      <g strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="6.2" />
        <circle cx="12" cy="12" r="2.2" />
        {/* 8 teeth */}
        <path d="M12 2.4 L12 5" />
        <path d="M12 19 L12 21.6" />
        <path d="M2.4 12 L5 12" />
        <path d="M19 12 L21.6 12" />
        <path d="M5.2 5.2 L7 7" />
        <path d="M17 17 L18.8 18.8" />
        <path d="M18.8 5.2 L17 7" />
        <path d="M7 17 L5.2 18.8" />
      </g>
    </svg>
  ),
  pencil: (s = 14) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M4 20 L4 16 L16 4 L20 8 L8 20 Z" />
      <path d="M14 6 L18 10" />
    </svg>
  ),
  book: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M5 4 H12 V20 H5 Z M19 4 H12 V20 H19 Z" />
      <path d="M5 4 C7 4.5 9.5 4.5 12 4 M19 4 C17 4.5 14.5 4.5 12 4" />
    </svg>
  ),
  help: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M9 9 C9 7 10.5 6 12 6 C13.5 6 15 7 15 9 C15 11 12 11 12 14" />
      <circle cx="12" cy="17.5" r="0.8" fill="currentColor" />
    </svg>
  ),
  refresh: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M4 12 A8 8 0 0 1 18 7" />
      <path d="M14 7 H19 V2" />
      <path d="M20 12 A8 8 0 0 1 6 17" />
      <path d="M10 17 H5 V22" />
    </svg>
  ),
  bell: (s = 20) => (
    <svg width={s} height={s} viewBox="0 0 24 24" {...stroke} strokeWidth="1.6">
      <path d="M6 16 C6 11 7 7 12 7 C17 7 18 11 18 16 L20 18 H4 Z" />
      <path d="M10 21 C10.5 21.7 11.2 22 12 22 C12.8 22 13.5 21.7 14 21" />
      <path d="M12 4 V7" />
    </svg>
  ),
};
